export enum ServiceType {
  Seat = 'Seat',
  Baggage = 'Baggage',
  Meal = 'Meal',
  Priority = 'Priority',
  Taxi = 'Taxi',
  Lounge = 'Loug',
}
